import React, { useState, useEffect } from 'react';
import CargaLaboresExcel from './CargaLaboresExcel';

const CargaRevisionLaboresExcel = () => {

    const [seccion, setseccion] = useState('CARGAR LABORES DESDE EXCEL');
    useEffect(() => {

    }, []);

    const botonSeccion = (localSeccion) => {
        return (<div className='bw-250'>
            <button className={`btn btn-sm btn-${localSeccion === seccion ? 'warning text-bold' : 'light shadow'} w-100`}
                style={{ transition: "all 0.3s ease" }}
                onClick={() => {
                    if (localSeccion === seccion) return;
                    setseccion(localSeccion);
                }}>{localSeccion}</button>
        </div>)
    }

    return (
        <>
            {/*<div className='w-100 m-0 p-0'>
                <div className='row justify-content-center w-100 m-0 p-0 mt-3'>
                    {botonSeccion('CARGAR LABORES DESDE EXCEL')}
                    {botonSeccion('REVISAR LABORES CARGADAS')}
                </div>
            </div>*/}
            {seccion === 'CARGAR LABORES DESDE EXCEL' &&
                <CargaLaboresExcel />
            }
        </>
    )
}

export default CargaRevisionLaboresExcel;